// extracted by mini-css-extract-plugin
module.exports = {"bufferGraph":"styles_bufferGraph__11I6X","bufferArea":"styles_bufferArea__aR-GE","bufferIndicator":"styles_bufferIndicator__2_9wV"};